<span class="ki-marker" [class.ki-marker--geaendert]="art() === 'geaendert'" [attr.title]="texte().titel | translate">
  <app-ki-mark [size]="13" />
  {{ texte().text | translate }}
</span>
